import React from 'react'
import clsx from 'clsx'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import styled from 'styled-components'
import { ParagraphComponentProps } from './ParagraphComponentProps'
import useStyles from './ParagraphComponent.styles'
import { TextAlignment } from '../../../data/types'
import PrimaryButton from '../../utils/PrimaryButton'
import mapStyles from '../../utils/mapStyles'
import MediaQueryName from '../../../data/types/MediaQueryName'
import { StyleBlock } from '../../../data/types/StyleBlock'
import MediaQueries from '../../../styles/MediaQueries'

const ParagraphContainer =  styled.div<{styles?: Record<MediaQueryName, StyleBlock>}>`
  padding: ${({ styles }) => `${styles?.[MediaQueryName.Default]?.paddingHeight ?? 0}px 25px`};

  @media ${MediaQueries.Tablet.substring(6)} {
    padding: ${({ styles }) => `${styles?.[MediaQueryName.Tablet]?.paddingHeight ?? 0}px 0px`};
  }

  @media ${MediaQueries.LaptopSmall.substring(6)} {
    padding: ${({ styles }) => `${styles?.[MediaQueryName.LaptopSmall]?.paddingHeight ?? 0}px 0px`};
  }

  @media ${MediaQueries.LaptopLarge.substring(6)} {
    padding: ${({ styles }) => `${styles?.[MediaQueryName.LaptopLarge]?.paddingHeight ?? 0}px 0px`};
  }

  @media ${MediaQueries.Desktop.substring(6)} {
    padding: ${({ styles }) => `${styles?.[MediaQueryName.Desktop]?.paddingHeight ?? 0}px 0px`};
  }
`

const ParagraphComponent: React.FC<Omit<ParagraphComponentProps, 'type'>> = ({
  textAlignment = TextAlignment.Left,
  sections,
  className,
  button,
  styles,
  inFeatureColumns
}) => {
  const styleMap = mapStyles(styles)
  const classes = useStyles({ textAlignment })
  return (
    <ParagraphContainer className={clsx(classes.paragraphContainer, className)} styles={styleMap}>
      <div className={clsx(classes.paragraph, className)}>
        {documentToReactComponents(sections)}
        {/* Hide buttons when inFeatureColumns is true and in web view */}
        <div className={clsx(inFeatureColumns && classes.button)}>
          {button && (
            <PrimaryButton
              isPrimary={button.isPrimary}
              href={button.href}
            >
              {button.text}
            </PrimaryButton>
          )}
        </div>
      </div>
    </ParagraphContainer>
  )
}

export default ParagraphComponent
